import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from './Carousel';
const testimonials = [{
  id: 1,
  quote: "Nathan made buying our first luxury home an absolute breeze. His attention to detail and knowledge of the market is unmatched. We couldn't be happier with our new home.",
  author: 'Sarah & James M.',
  descriptor: 'First-Time Buyers'
}, {
  id: 2,
  quote: "Selling a property can be stressful, but Nathan's strategic approach and marketing expertise got us multiple offers above asking price within the first week.",
  author: 'David R.',
  descriptor: 'Seller'
}, {
  id: 3,
  quote: 'As an investor, I need an agent who understands the numbers. Nathan consistently brings me off-market opportunities that align perfectly with my portfolio goals.',
  author: 'Elena T.',
  descriptor: 'Real Estate Investor'
}];
export function Testimonials() {
  return <section className="py-20 md:py-32 bg-warm-gray overflow-hidden" data-id="element-159">
      <div className="container mx-auto px-6" data-id="element-160">
        <div className="text-center mb-16" data-id="element-161">
          <motion.span initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="block text-gold font-heading text-sm uppercase tracking-widest font-semibold mb-4" data-id="element-162">
            Client Experiences
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="font-heading text-3xl md:text-4xl lg:text-5xl text-charcoal uppercase tracking-wide" data-id="element-163">
            What Clients Are Saying
          </motion.h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-4xl mx-auto relative" data-id="element-164">
          <Carousel className="w-full" data-id="element-165">
            <CarouselContent data-id="element-166">
              {testimonials.map(testimonial => <CarouselItem key={testimonial.id} data-id="element-167">
                  <div className="flex flex-col items-center text-center px-4 md:px-16 py-8" data-id="element-168">
                    <Quote className="h-16 w-16 text-gold mb-8 opacity-50" data-id="element-169" />
                    <p className="font-body text-xl md:text-2xl text-charcoal italic leading-relaxed mb-10" data-id="element-170">
                      "{testimonial.quote}"
                    </p>
                    <div className="font-heading uppercase tracking-wider" data-id="element-171">
                      <p className="text-charcoal font-semibold" data-id="element-172">
                        {testimonial.author}
                      </p>
                      <p className="text-charcoal/60 text-sm mt-1" data-id="element-173">
                        {testimonial.descriptor}
                      </p>
                    </div>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            <div className="hidden md:block" data-id="element-174">
              <CarouselPrevious className="left-0 border-charcoal text-charcoal hover:bg-charcoal hover:text-white" data-id="element-175" />
              <CarouselNext className="right-0 border-charcoal text-charcoal hover:bg-charcoal hover:text-white" data-id="element-176" />
            </div>
          </Carousel>
        </motion.div>
      </div>
    </section>;
}